module.exports = __webpack_public_path__ + "static/ziarna_tlo_opak-fa99bf977c78fae7b941e7085592b3e7.png";